import { render, staticRenderFns } from "./WalkCustomerModel.vue?vue&type=template&id=182b5264&"
import script from "./WalkCustomerModel.vue?vue&type=script&lang=js&"
export * from "./WalkCustomerModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports